import FilesPageView from "./FilesPageView";

function FilesPage() {
  return <FilesPageView />;
}

export default FilesPage;
